module.exports = __webpack_public_path__ + "static/media/truser.45407904.png";